import { ISobCompetitorsDependOnSettings } from 'partner360/models/ISobCompetitorsDependOnSettings'
import { ISobCompetitorsGroup } from 'partner360/models/ISobCompetitorsGroup'

interface IIsEditableCondition {
  otherKey: string
  expandedKeys: string[]
}

export const isEditableCondition =
  ({ otherKey, expandedKeys }: IIsEditableCondition) =>
  (comp: ISobCompetitorsDependOnSettings, item: ISobCompetitorsGroup) =>
    !(comp.CompetitorID === otherKey || expandedKeys.includes(item.EntryId))
